<template>
	<div class="navBar d-flex j-sb a-center">
		<div class="left d-flex j-start a-center">
			<img src="../../assets/Home/qywwz.png" style="width: 2.5rem;height: 2.5rem;margin-right: 1.59rem;border-radius: 5px;">
			<span style="font-size: 1.88rem;font-weight: 700;">后台管理系统</span>
		</div>
		<div class="center d-flex j-start a-center">
			<div  class="button" v-for="(item,index) in option" :key="index">
				<router-link  :to="item.path" v-slot="{ href, route, navigate, isActive, isExactActive }" custom 
				v-if="item.name!='品牌管理'&&item.name!='说品商城'">
					<a :href="href" class="d-flex j-center a-center" :style="isActive?'color:#FFFFFF;border-color:#FFFFFF;':''"
					 @mouseover="cur_hover=index" @mouseleave="cur_hover=null">
						<img :src="isActive||(cur_hover==index)?item.icon_active:item.icon" style="width: 1.15rem;height: 1.15rem;margin-right: 0.38rem;">
						<span>{{item.name}}</span>
					</a>
				</router-link>
				<router-link :to="item.path" v-slot="{ href, route, navigate, isActive, isExactActive }" custom 
				v-else-if="item.name=='说品商城'&&multiport==0">
					<a :href="href" class="d-flex j-center a-center" :style="isActive?'color:#FFFFFF;border-color:#FFFFFF;':''"
					 @mouseover="cur_hover=index" @mouseleave="cur_hover=null">
						<img :src="isActive||(cur_hover==index)?item.icon_active:item.icon" style="width: 1.15rem;height: 1.15rem;margin-right: 0.38rem;">
						<span>{{item.name}}</span>
					</a>
				</router-link>
				<router-link :to="item.path" v-slot="{ href, route, navigate, isActive, isExactActive }" custom
				v-else-if="item.name=='品牌管理'&&multiport==1">
					<a :href="item.path" class="d-flex j-center a-center" :style="isActive?'color:#FFFFFF;border-color:#FFFFFF;':''"
					 @mouseover="cur_hover=index" @mouseleave="cur_hover=null">
						<img :src="isActive||(cur_hover==index)?item.icon_active:item.icon" style="width: 1.15rem;height: 1.15rem;margin-right: 0.38rem;">
						<span>{{item.name}}</span>
					</a>
				</router-link>
			</div>
			
		</div>
		<el-row class="right d-flex j-start a-center" style="font-size: 0.88rem; width: 17rem;" type="flex" justify="space-between">
			<!-- <el-col :span="6">
				<div @click="openView()" class="d-flex a-center">
					<img style="width: 20px;height: 20px;" src="../../assets/Home/ppglxz.png" />
					<span class="ppgl" style="font-size: 12px;cursor: pointer;">品牌管理</span>
				</div>
			</el-col> -->
			<el-col :span="3">
				<el-avatar :src="user_info.logo_thumb" style="border: 2px solid #FFFFFF;width: 2.5rem;height: 2.5rem;"></el-avatar>
			</el-col>
			<el-col :span="9">
				<router-link to="#" v-slot="{ href, route, navigate, isActive, isExactActive }" custom class="username">
					<a :href="href">{{user_info.user_name}}</a>
				</router-link>
			</el-col>
			<el-col :span="3">
				<span class="logout" @click="logout">退出</span>
			</el-col>
			<el-col :span="2" style="display: flex;align-items: center;cursor: pointer;">
				<img @click="$router.push('/forgetPass')" style="width: 18px;height: 19px;" src="../../assets/Home/set.png" />
			</el-col>
			<el-col :span="2" style="display: flex;align-items: center;cursor: pointer;">
				<img @click="message()" style="width: 18px;height: 19px;" src="../../assets/Home/xiaoxi@2x.png" />
			</el-col>
			<!-- <img src="" /> -->
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				multiport:localStorage.getItem('multiport'),
				cur_hover: null,
				option: [{
					path: '/Home',
					name: '首页',
					icon: require('@/assets/Home/shouyemr@2x.png'),
					icon_active: require('@/assets/Home/shouye@2x.png')
				},{
					path: '/modular_admin',
					name: '模块管理',
					icon: require('@/assets/Home/pinpaizhuangxiu@2x.png'),
					icon_active: require('@/assets/Home/pinpaizhuangxiuxz@2x.png')
				},{
					path: '/enterprise_info',
					name: '企业信息',
					icon: require('@/assets/Home/zlxzmr.png'),
					icon_active: require('@/assets/Home/zlxz.png')
				},{
					path: '/brand_fixtures',
					name: '企业装修',
					icon: require('@/assets/Home/pinpaizhuangxiu@2x.png'),
					icon_active: require('@/assets/Home/pinpaizhuangxiuxz@2x.png')
				},{
					path: '/item_store',
					name: '产品/服务',
					icon: require('@/assets/Home/shangpinku@2x.png'),
					icon_active: require('@/assets/Home/shangpinkuxz@2x.png')
				}, {
					path: '/ent_dynamic',
					name: '企业动态',
					icon: require('@/assets/Home/qydtxzmr.png'),
					icon_active: require('@/assets/Home/qydtxz.png')
				}, 
				// {
				// 	path: '/upload_data',
				// 	name: '企业资料',
				// 	icon: require('@/assets/Home/fenxiaoshang@2x.png'),
				// 	icon_active: require('@/assets/Home/fenxiaoshangxz@2x.png')
				// }, 
				{
					path: '/cooperation',
					name: '合作伙伴',
					icon: require('@/assets/Home/baobiao@2x.png'),
					icon_active: require('@/assets/Home/baobiaoxz@2x.png')
				}, {
					path: '/business_card',
					name: '企业名片',
					icon: require('@/assets/Home/qympxzmr.png'),
					icon_active: require('@/assets/Home/qympxz.png')
				},{
					path: '/staff',
					name: '人员管理',
					icon: require('@/assets/Home/ygglxz.png'),
					icon_active: require('@/assets/Home/ygglxzmr.png')
				},{
					path: '/release_info',
					name: '信息发布',
					icon: require('@/assets/Home/xxfbxzmr.png'),
					icon_active: require('@/assets/Home/xxfbxz.png')
				}],
				user_info: ''
			}
		},
		mounted() {
			this.user_info = JSON.parse(localStorage.getItem('user_info'))
			
			if(this.multiport == 1){
				this.option.push({
					path: 'http://microweb.cn/pcAdmin/#/Login?user_info='+localStorage.getItem('user_info')+'&token='+localStorage.getItem('token'),
					name: '品牌管理',
					icon: require('@/assets/Home/ppglxz_mr.png'),
					icon_active: require('@/assets/Home/ppglxz(2).png')
				})
			}
			if(this.multiport == 0){
				this.option.push({
					path: '/shopindex',
					name: '说品商城',
					icon: require('@/assets/Home/shuopinmoren.png'),
					icon_active: require('@/assets/Home/shuopin@2x.png')
				})
			}
		},
		methods: {
			logout() {
				localStorage.removeItem('token')
				localStorage.removeItem('user_info')
				localStorage.removeItem('user_id')
				this.$router.push('/Login')
			},
			message(){
				this.$router.push('/message')
			},
			openView(){
				// location.href = 'http://localhost:8081/#/Login?user_info='+localStorage.getItem('user_info')+'&token='+localStorage.getItem('token')
				location.href = 'http://xy.spmall.com/pc/index.html#/Login?user_info='+localStorage.getItem('user_info')+'&token='+localStorage.getItem('token')
			}
		}
	}
</script>

<style scoped lang="less">
	 .ppgl:hover{
		 color: #FFFFFF;
	 }
	 .ppgl{
		 color: #888888;
	 }
	.navBar {
		flex-shrink: 0;
		height: 4.68rem;
		width: 100%;
		background: #262B34;
		color: #FFFFFF;
		padding: 0 3.9rem;
		box-sizing: border-box;
		box-shadow: 0px 8px 7px 0px rgba(0, 0, 0, 0.04);
		z-index: 999;
		position: relative;
		.left{
			flex: 1;
		}
		.center {
			width: 50rem;
			height: 100%;
			font-size: 0.75rem;
			flex: 4;
			.button{
				margin: 1.5%;
			}
			a {
				color: #888888;
				text-decoration: none;
				border-bottom: 2px solid transparent;

				&:hover {
					color: #FFFFFF;
				}
			}
		}

		.right {
			flex: 1;
			.username {
				color: #FFFFFF;
				text-decoration: none;

				&:hover {
					text-decoration: underline;
				}
			}

			.logout {
				border-bottom: 2px solid transparent;
				cursor: pointer;
				color: #1E69FF;

				&:hover {
					border-color: #1E69FF;
				}
			}
		}
	}
</style>
